import { Injectable } from '@angular/core';
import { FeatureFlagState, FeatureFlagStore } from './feature-flag.store';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(private store: FeatureFlagStore) {}

  setValue(key: string, value: boolean): void {
    this.store.update((state: FeatureFlagState) => ({
      ...state,
      [key]: value
    }));
  }
}
